import { cdataFetch } from "src/api/cdataFetch";
import { ISelfServiceBillingPlansResponse } from "src/bffmodels/Billing/SelfServiceBilling/ISelfServiceBillingPlansResponse";

export async function getSelfServicePlans() {
  return await cdataFetch<ISelfServiceBillingPlansResponse>({
    method: "GET",
    url: "selfServiceBilling/plans",
  });
}
